import { Route, Routes } from "react-router-dom";

import {
  LoginPage,
  BuzonDeDenunciasPage,
  EducacionPage,
  CursoCompradoPage,
  NotFoundPage,
  CursoDisponiblePage,
  CertificadoWebinarPage,
  CertificadoAulaPage,
  CertificadoAlumnoAulaPage,
  ReestablecerContrasenaPage,
  AulaInicioPage,
  EnrollmentProgressPage,
  LessonContentPage,
} from "./pages";
import { ProtectedRoute } from "./utils";
import SupportLoader from "./components/SupportLoader";

import "./styles/styles.css";

export default function App() {
  return (
    <>
      <SupportLoader />

      <Routes>
        <Route path="/" element={<LoginPage />}></Route>
        <Route
          path="inicio"
          element={<ProtectedRoute children={<AulaInicioPage />} />}
        />
        <Route path="aula-virtual">
          <Route
            path=":id"
            element={<ProtectedRoute children={<EnrollmentProgressPage />} />}
          />
          <Route
            path=":id/content/:lessonId"
            element={<ProtectedRoute children={<LessonContentPage />} />}
          />
          <Route
            path=":id/certificado-alumno"
            element={<CertificadoAlumnoAulaPage />}
          />
          <Route
            index
            element={<ProtectedRoute children={<EducacionPage />} />}
          />
          <Route
            path="cursos-activos/:code"
            element={<ProtectedRoute children={<CursoCompradoPage />} />}
          />
          <Route
            path="cursos-disponibles/:code"
            element={<ProtectedRoute children={<CursoDisponiblePage />} />}
          />
          <Route
            path="cursos-anteriores/:code"
            element={<ProtectedRoute children={<CursoCompradoPage />} />}
          />
        </Route>
        <Route
          path="buzon-de-denuncias"
          element={<ProtectedRoute children={<BuzonDeDenunciasPage />} />}
        />
        <Route path="certificado-webinar">
          <Route path=":code">
            <Route index element={<CertificadoWebinarPage />} />
          </Route>
        </Route>
        <Route path="certificado-aula">
          <Route path=":code">
            <Route index element={<CertificadoAulaPage />} />
          </Route>
        </Route>
        <Route path="certificado-alumno-aula">
          <Route path=":estudiante/:curso">
            <Route index element={<CertificadoAlumnoAulaPage />} />
          </Route>
        </Route>
        <Route
          path="reestablecer-contrasena/:uidb64/:token"
          element={<ReestablecerContrasenaPage />}
        />
        <Route
          path="*"
          element={<ProtectedRoute children={<NotFoundPage />} />}
        />
      </Routes>
    </>
  );
}
